module.exports = __webpack_public_path__ + "static/media/bat.7fd1ecd2.svg";